import { render } from "./HistoryResults.vue?vue&type=template&id=19faf03a&ts=true"
import script from "./HistoryResults.vue?vue&type=script&lang=ts"
export * from "./HistoryResults.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__